import { getContentTypeFromFileName } from '@pixacare/file-upload';

// A file is a video when its MIME type says so, or — for containers the browser leaves with an
// empty MIME type (e.g. .mkv) — when its extension maps to a video content type.
export const isVideoFile = (file: File): boolean =>
  (file.type || getContentTypeFromFileName(file.name)).startsWith('video/');
